/**************************************************
 * Nombre:       Tarjetas_Producto_Especificacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Producto_Especificacion = ({item, click, index}) => {


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', p: 1, cursor: 'pointer'}}
            spacing={0}
        >


            <Grid container size={6}>
                <Typography
                    sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                <Typography
                    sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.descripcion}`}</Typography>
            </Grid>




        </Grid>


    )

}
export default Tarjetas_Producto_Especificacion